import { createSlice } from "@reduxjs/toolkit";

const routeDataSlice = createSlice({
    name:'routeData',
    initialState:{
        data:null,
        loading:false,
        err : null,
    },
    reducers:{
        setRouteData(state, action) {
            state.data = action.payload;
            state.loading = false;
        },
        setLoading(state) {
            state.loading = true;
        },
        setError(state, action) {
            state.error = action.payload;
            state.loading = false;
        },
        clearRouteData(state) {
            state.data = null;
        },
    }
})

export const { setRouteData, setLoading, setError, clearRouteData } = routeDataSlice.actions;
export default routeDataSlice.reducer;